// do not restore scroll position
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}